export default __webpack_public_path__ + "static/media/is.bb94eeba.svg";